import React from 'react';
import { AppPlatform, AppStoreType } from '../../types';
import Space from 'antd/lib/space';
import { displayTextForReleaseStepType } from '../../helpers/displayHelpers';
import Text from 'antd/lib/typography/Text';
import { StepGraphStep } from '@/types/workflow';
import Divider from 'antd/lib/divider';
import { antGrey } from '../styles/globalStyles';

interface InlineStepConfigDescriptionProps {
    stepGraphStep: StepGraphStep;
    platform: AppPlatform;
    appStoreType: AppStoreType;
    isWorkflowsCIStepEnabled: boolean;
    archetypeMinWidth?: number;
}

export const InlineStepConfigDescription: React.FC<InlineStepConfigDescriptionProps> = ({
    stepGraphStep,
    platform,
    appStoreType,
    isWorkflowsCIStepEnabled,
    archetypeMinWidth,
}) => {
    return (
        <Space
            style={{
                padding: '0 8px',
            }}
            size={2}
            split={
                <Divider
                    type={'vertical'}
                    style={{
                        height: 20,
                        borderColor: antGrey.grey6,
                    }}
                />
            }
        >
            <Text
                type="secondary"
                style={archetypeMinWidth ? { minWidth: archetypeMinWidth, display: 'inline-block' } : undefined}
            >
                {displayTextForReleaseStepType(
                    stepGraphStep.archetype,
                    platform,
                    appStoreType,
                    isWorkflowsCIStepEnabled,
                )}
            </Text>
            <Text>{stepGraphStep.stepName}</Text>
        </Space>
    );
};
